/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Entry fee range in FUEL
 * @export
 * @interface HubChallengeConfigResponseEntryFeeRange
 */
export interface HubChallengeConfigResponseEntryFeeRange {
    /**
     * 
     * @type {number}
     * @memberof HubChallengeConfigResponseEntryFeeRange
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof HubChallengeConfigResponseEntryFeeRange
     */
    max?: number;
}

/**
 * Check if a given object implements the HubChallengeConfigResponseEntryFeeRange interface.
 */
export function instanceOfHubChallengeConfigResponseEntryFeeRange(value: object): value is HubChallengeConfigResponseEntryFeeRange {
    return true;
}

export function HubChallengeConfigResponseEntryFeeRangeFromJSON(json: any): HubChallengeConfigResponseEntryFeeRange {
    return HubChallengeConfigResponseEntryFeeRangeFromJSONTyped(json, false);
}

export function HubChallengeConfigResponseEntryFeeRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HubChallengeConfigResponseEntryFeeRange {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function HubChallengeConfigResponseEntryFeeRangeToJSON(json: any): HubChallengeConfigResponseEntryFeeRange {
    return HubChallengeConfigResponseEntryFeeRangeToJSONTyped(json, false);
}

export function HubChallengeConfigResponseEntryFeeRangeToJSONTyped(value?: HubChallengeConfigResponseEntryFeeRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

